import React from "react";
import PropTypes from "prop-types";

import { ReactComponent as CircularProgress } from "assets/img/ONYX_X_logo.svg";
import { Typography } from "@mui/material";
import { styled } from "@mui/material/styles";

function ProgressIndicatorComp({
  loading,
  error,
  errorMessage = "Failed to load content...",
  delay = 0
}) {
  if (loading) {
    return (
      <ProgressWrapper delay={delay}>
        <StyledCircularProgress
          data-qa="circular-progress-indicator"
          aria-label="circular progress indicator"
          aria-busy={true}
        />
      </ProgressWrapper>
    );
  }

  if (error) {
    console.error(error);
    return <Typography align="center">{errorMessage}</Typography>;
  }

  return null;
}

const ProgressWrapper = styled("div")`
  @keyframes appear {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }

  opacity: 0;
  animation: appear 500ms linear ${props => props.delay}ms forwards;
`;

const StyledCircularProgress = styled(CircularProgress)`
  @keyframes rotation {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(360deg);
    }
  }

  position: absolute;
  top: 50%;
  left: 50%;
  z-index: 100000;
  animation: rotation 2s infinite linear;
`;

ProgressIndicatorComp.propTypes = {
  loading: PropTypes.bool.isRequired,
  error: PropTypes.oneOfType([PropTypes.object, PropTypes.bool]),
  errorMessage: PropTypes.string,
  delay: PropTypes.number
};

const ProgressIndicator = React.memo(ProgressIndicatorComp);

export default ProgressIndicator;
